angular.module('project')
    .controller("ProjectUploadClassificationController", function ($uibModalInstance, data, $rootScope, toastr, AgreementService, AgreementOfferService, WorkflowService, PowerOfAttorneyService, ServiceRequestService, ProjectService, InvoiceService) {
        this.form = data;
        this.types = [ 'POWER_OF_ATTORNEY', 'SERVICE_REQUEST', 'AGREEMENT', 'ORDER', 'OFFER', 'INVOICE', 'WORKFLOW' ];

        this.$onInit = () => {

        }

        this.save = () => {
            switch (this.form.type) {
                case 'POWER_OF_ATTORNEY':
                    this.cancel();
                    return PowerOfAttorneyService.add({file: this.form.file, project: this.form.project, description: this.form.description});
                case 'SERVICE_REQUEST':
                    this.cancel();
                    let subjectOfClaim = {
                        project: this.form.project
                    }
                    return ServiceRequestService.add({file: this.form.file, subjectOfClaim: subjectOfClaim, description: this.form.description});
                case 'AGREEMENT':
                    this.cancel();
                    return AgreementService.add({type: 'AGREEMENT', attachments: [this.form.file], subject: this.form.description});
                case 'ORDER':
                    this.cancel();
                    return AgreementService.add({type: 'ORDER', attachments: [this.form.file], subject: this.form.description})
                case 'OFFER':
                    this.cancel();
                    return AgreementService.add({type: 'OFFER', attachments: [this.form.file], subject: this.form.description})
                case 'INVOICE':
                    this.cancel();
                    return InvoiceService.createFromClassification(this.form)
                case 'WORKFLOW':
                    this.cancel();
                    return WorkflowService.createFromClassification(this.form)
                default:
                        toastr.error("Nieobsługiwany typ dokumentu");
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
